import styled from 'styled-components';

export const EvenlySpacedItemsList = styled.ul`
  display: grid;
  grid-auto-rows: 1fr;
`;
